import PersonAttachmentsPageContent from '@/components/PersonAttachmentsPageContent';
import { useStaffMemberInfoContext } from '../StaffMemberInfo/StaffMemberInfo.context';

const StaffMemberAttachments = (): JSX.Element => {
  const { staffMember } = useStaffMemberInfoContext();

  return <PersonAttachmentsPageContent person={staffMember?.person} />;
};

export default StaffMemberAttachments;
